export const OCR_STATUS = {
  'NOT_YET_OCR':     0, // Chưa OCR
  'PROCESSING_OCR':  1, // Đang chờ OCR
  'DONE_OCR':        2, // Đã OCR
  'WAITING_APPROVE': 3, // Chờ duyệt chỉnh lý
  'DONE':            4, // Đã duyệt chỉnh lý
}

export const NULL_CHARACTER = '&nbsp;&nbsp;&nbsp;'